import type { SubListType } from '@/domains/docs-site/ApiFolderSubListBuilder';
import type { ApiFolderServerType } from '@/services/api-folder/apiFolder';
import type { ApiFieldList } from '@/shared/constant/ApiFieldList';
import { FOLDER_CONTENTS_DISPLAYING_SETTINGS } from '@tarslib/types/lib/httpFolder';
import { BottomBanner } from '../bottom-banner/BottomBanner';
import { DocContent } from '../doc-content/DocContent';
import { DocsBreadcrumb } from '../docs-breadcrumb/DocsBreadcrumb';
import { Footer } from '../footer/Footer';
import { LastModifiedAt } from '../last-modified-at/LastModifiedAt';
import { Paginator } from '../paginator/Paginator';
import { ResourceHeader } from '../resource-header/ResourceHeader';
import { FolderCardList } from './components/folder-card-list/FolderCardList';

export type ApiFolderContentProps = {
  value: ApiFolderServerType;
  extraData: {
    subList: SubListType[];
    apiFieldList: ApiFieldList[];
  };
};

export function ApiFolderContent(props: ApiFolderContentProps) {
  const { value, extraData } = props;
  const subList = extraData.subList;

  if (
    value.folderContentsDisplayingSettings === FOLDER_CONTENTS_DISPLAYING_SETTINGS.CUSTOM_CONTENT &&
    value.folderDoc
  ) {
    return <DocContent value={value.folderDoc} />;
  }

  return (
    <div className="os:pt-5">
      <DocsBreadcrumb className="mb-2 hidden os:block" />
      <ResourceHeader className="mb-4" name={value.name} />

      <FolderCardList value={subList} />

      <BottomBanner className="mb-8" />

      <LastModifiedAt className="mb-14 mt-8" />

      <Paginator className="mb-10" />

      <Footer />
    </div>
  );
}
